module.exports = __webpack_public_path__ + "img/reproductor.57ab1ae2.png";